import { Stack, Typography } from '@mui/material';

import { Icon } from '@/components/shared/icon';

interface SnapshotSelectionEmptyStateProps {
  description: string;
  icon?: string;
}

export default function SnapshotSelectionEmptyState(
  props: SnapshotSelectionEmptyStateProps
) {
  const { description, icon } = props;

  return (
    <Stack
      width={'100%'}
      height={'100%'}
      alignItems={'center'}
      justifyContent={'center'}
      spacing={'24px'}
    >
      {icon && <Icon iconClass={icon} />}
      <Typography variant='body1'>{description}</Typography>
    </Stack>
  );
}
